import { Fragment, memo, useMemo, useRef } from "react";

import styled from "styled-components";
import ButtonIcon from "components/ui-kit/ButtonIcon";

// icons
import { ArrowBack, Add, Close } from "@mui/icons-material";

// transition
import { CSSTransition } from "react-transition-group";

// steps
import {
  SidebarStepSelectRestaurant,
  SidebarStepSelectProductCategory,
  SidebarStepSelectItem,
  SidebarStepUnknown, // unknown step
} from "./steps";

// step constants
import { SPECIFICATIONS_PAGE_STEPS as STEPS } from "constants/specificationsPageSteps";

const getSidebarByStep = (step) => useMemo(() => {
  switch (step) {
    case STEPS.STEP_SIDEBAR_HIDDEN: return SidebarStepSelectRestaurant; // For smooth transition
    case STEPS.STEP_SELECT_RESTAURANT: return SidebarStepSelectRestaurant;
    case STEPS.STEP_SELECT_PRODUCT_CATEGORY: return SidebarStepSelectProductCategory;
    case STEPS.STEP_SELECT_PRODUCT: return SidebarStepSelectItem;
    default: return SidebarStepUnknown;
  }
}, [step]);

const getIconByStep = (step) => useMemo(() => {
  if (step === 0) {
    return Add;
  } else if (step > 1) {
    return ArrowBack;
  } else {
    return Close;
  }
}, [step]);

const Sidebar = ({
  // state
  step = 0,
  loading = false,
  // dispatch
  beginNextStep = () => { },
  beginPreviousStep = () => { },
}) => {
  // sidebar ref
  const nodeRef = useRef(null);

  const Step = getSidebarByStep(step);
  const Icon = getIconByStep(step);

  // Is sidebar open
  const isOpen = step > 0;

  return (
    <Fragment>
      <Navigation>
        <ButtonIcon
          icon={<Icon />}
          onClick={isOpen ? beginPreviousStep : beginNextStep}
          disabled={loading}
          isLoad={loading}
        />
      </Navigation>

      {/* Animated sidebar transition */}
      <CSSTransition
        in={isOpen}
        nodeRef={nodeRef}
        timeout={300}
        classNames="left-to-right"
        unmountOnExit
      >
        <Wrapper ref={nodeRef}>
          <Step loading={loading} />
        </Wrapper>
      </CSSTransition>

    </Fragment>
  );
}

const Wrapper = styled.div`
    position: relative;
    left: 0;
    top: 0;
    // z-index: 1000;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 460px;
    flex: 0 0 25%;
`;

const Navigation = styled.div`
    position: absolute;
    left: 14px;
    z-index: 999;
`;

export default memo(Sidebar);
